import { getStaticCustomDomainMapping } from '../config/customDomainMappings';
import { getReturnTo, inferOrgSlugFromPath, sanitizeReturnTo } from './authRedirect';

// Explicit page/domain context wins over a previously visited organization.
export function organizationAuthContext(location, stored = {}, host = window.location.host, resolvedDomainOrg = '') {
  const params = new URLSearchParams(location?.search || '');
  const domainOrg = resolvedDomainOrg || getStaticCustomDomainMapping(host)?.orgSlug || '';
  const requested = getReturnTo(location, '');
  const orgSlug = domainOrg || params.get('org') || inferOrgSlugFromPath(requested) || stored.orgSlug || '';
  const memberHome = domainOrg ? '/me' : orgSlug ? `/${orgSlug}/me` : '';
  const storedPath = !params.has('org') && !domainOrg && stored.orgSlug === orgSlug ? sanitizeReturnTo(stored.returnPath, '') : '';
  const destination = requested || storedPath || memberHome;
  const pathname = destination.split(/[?#]/)[0].replace(/\/$/, '') || '/';
  const isOrgHome = orgSlug && ['/', `/${orgSlug}`, `/o/${orgSlug}`].includes(pathname);
  return { orgSlug, returnTo: isOrgHome ? memberHome : destination, memberHome };
}

export function organizationActionSettings(context, origin = window.location.origin) {
  const url = new URL('/auth/action', origin);
  if (context.orgSlug) url.searchParams.set('org', context.orgSlug);
  if (context.returnTo) url.searchParams.set('returnTo', context.returnTo);
  return { url: url.href, handleCodeInApp: true };
}
